// extracted by mini-css-extract-plugin
module.exports = {"social":"Social_social__HMBUx","social__item":"Social_social__item__AFJX_"};